import { formatNumber, useSum } from '@ijoin/components';
import { useGetManagedAccountMethodologyAdvisoryOrganizationsSuspense } from '@ijoin/hooks';
import { Card, CardContent, Grid, Typography } from '@mui/material';

import { FC } from 'react';

type MethodologyMetricTilesProps = {
  managedAccountMethodologyId: string;
};

export const MethodologyMetricTiles: FC<
  MethodologyMetricTilesProps
> = props => {
  const associations =
    useGetManagedAccountMethodologyAdvisoryOrganizationsSuspense(
      props.managedAccountMethodologyId
    );

  const activePlans = useSum(associations.data, 'activePlansCount');
  const activeParticipants = useSum(
    associations.data,
    'managedParticipantsCount'
  );

  return (
    <Grid container spacing={2}>
      {[
        {
          label: 'Active Plans',
          testId: 'methodologyActivePlans',
          value: formatNumber(activePlans)
        },
        {
          label: 'Active Participants',
          testId: 'methodologyActiveParticipants',
          value: formatNumber(activeParticipants)
        }
      ].map(tile => (
        <Grid key={tile.label} size={{ sm: 6, xs: 12 }}>
          <Card data-testid={tile.testId}>
            <CardContent>
              <Typography color='text.secondary' variant='overline'>
                {tile.label}
              </Typography>
              <Typography variant='h5'>{tile.value}</Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};
